"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.camelCaseKeysToUnderscore = void 0;
exports.checkAuthTokenUsage = checkAuthTokenUsage;
exports.convertSnakeCaseToSentenceCase = exports.convertOcapiFaultToCapiError = exports.checkRequiredParameters = void 0;
exports.createGetTokenBody = createGetTokenBody;
exports.handleAsyncError = exports.getTenantId = exports.createScapiFetch = exports.createOcapiFetch = void 0;
exports.hasSFRAAuthStateChanged = hasSFRAAuthStateChanged;
exports.isError = void 0;
exports.isTokenExpired = isTokenExpired;
exports.noop = exports.keysToCamel = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _jwtDecode = _interopRequireDefault(require("jwt-decode"));
var _url = require("@salesforce/pwa-kit-react-sdk/utils/url");
var _errors = require("@salesforce/pwa-kit-react-sdk/ssr/universal/errors");
var _constants = require("./constants");
var _crossFetch = _interopRequireDefault(require("cross-fetch"));
var _queryString = _interopRequireDefault(require("query-string"));
var Sentry = _interopRequireWildcard(require("@sentry/react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */ // @ts-ignore
// @ts-ignore
/**
 * Compares the token age against the issued and expiry times. If the token's age is
 * within 60 seconds of its valid time (or exceeds it), we consider the token invalid.
 * @function
 * @param {string} token - The JWT bearer token to be inspected
 * @returns {boolean}
 */
function isTokenExpired(token) {
  if (!token) {
    return true;
  }
  const {
    exp,
    iat
  } = (0, _jwtDecode.default)(token.replace('Bearer ', ''));
  const validTimeSeconds = exp - iat - 60;
  const tokenAgeSeconds = Date.now() / 1000 - iat;
  if (validTimeSeconds > tokenAgeSeconds) {
    return false;
  }
  return true;
}

// Returns fomrulated body for SopperLogin getToken endpoint
function createGetTokenBody(urlString, slasCallbackEndpoint, codeVerifier) {
  const url = new URL(urlString);
  const urlParams = new URLSearchParams(url.search);
  const usid = urlParams.get('usid');
  const code = urlParams.get('code');
  return {
    grantType: 'authorization_code_pkce',
    code,
    usid,
    codeVerifier: codeVerifier,
    redirectUri: slasCallbackEndpoint
  };
}

// Ocapi related utilities

const toCamel = str => {
  if (str.startsWith('_') || str.startsWith('c_')) {
    return str;
  }
  return str.replace(/([-_][a-z])/gi, $1 => {
    return $1.toUpperCase().replace('-', '').replace('_', '');
  });
};
const isObject = obj => {
  return obj === Object(obj) && !Array.isArray(obj) && typeof obj !== 'function';
};

// @ts-ignore
const keysToCamel = obj => {
  if (isObject(obj)) {
    const n = {};
    Object.keys(obj).forEach(k => {
      // @ts-ignore
      n[toCamel(k)] = keysToCamel(obj[k]);
    });
    return n;
  } else if (Array.isArray(obj)) {
    // @ts-ignore
    return obj.map(i => {
      return keysToCamel(i);
    });
  }
  return obj;
};
exports.keysToCamel = keysToCamel;
const camelCaseKeysToUnderscore = _obj => {
  if (typeof _obj != 'object') return _obj;

  // Copy the incoming object so we dont mutate it
  let obj;
  if (Array.isArray(_obj)) {
    obj = [..._obj];
  } else {
    obj = _objectSpread({}, _obj);
  }
  for (var oldName in obj) {
    // Ignore custom properties
    if (oldName.substring(0, 2) === 'c_') {
      continue;
    }

    // Camel to underscore
    let newName = oldName.replace(/([A-Z])/g, $1 => {
      return '_' + $1.toLowerCase();
    });

    // Only process if names are different
    if (newName != oldName) {
      // Check for the old property name to avoid a ReferenceError in strict mode.
      if (Object.prototype.hasOwnProperty.call(obj, oldName)) {
        obj[newName] = obj[oldName];
        delete obj[oldName];
      }
    }

    // Recursion
    if (typeof obj[newName] == 'object') {
      obj[newName] = camelCaseKeysToUnderscore(obj[newName]);
    }
  }
  return obj;
};

// This function coverts errors/faults returned from the OCAPI API to the format that is returned from the CAPI
// I added the fault key to make life easier as it's hard to discern a CAPI error
exports.camelCaseKeysToUnderscore = camelCaseKeysToUnderscore;
const convertOcapiFaultToCapiError = error => {
  return {
    title: error.message,
    type: error.type,
    detail: error.message,
    // Unique to OCAPI I think
    arguments: error.arguments,
    fault: true
  };
};

// This function checks required parameters and or body for requests to OCAPI endpoints before sending
exports.convertOcapiFaultToCapiError = convertOcapiFaultToCapiError;
const checkRequiredParameters = (listOfPassedParameters, listOfRequiredParameters) => {
  const isBodyOnlyRequiredParam = listOfRequiredParameters.includes('body') && listOfRequiredParameters.length === 1;
  if (!listOfPassedParameters.parameters && !isBodyOnlyRequiredParam) {
    return {
      title: `Parameters are required for this request`,
      type: `MissingParameters`,
      detail: `Parameters are required for this request`
    };
  }
  if (listOfRequiredParameters.includes('body') && !listOfPassedParameters.body) {
    return {
      title: `Body is required for this request`,
      type: `MissingBody`,
      detail: `Body is  required for this request`
    };
  }
  if (isBodyOnlyRequiredParam && listOfRequiredParameters.includes('body') && listOfPassedParameters.body) {
    return undefined;
  }
  let undefinedValues = listOfRequiredParameters.filter(req => !Object.keys(listOfPassedParameters.parameters).includes(req));
  undefinedValues = undefinedValues.filter(value => value !== 'body');
  if (undefinedValues.length) {
    return {
      title: `The following parameters were missing from your resquest: ${undefinedValues.toString()}`,
      type: `MissingParameters`,
      detail: `The following parameters were missing from your resquest: ${undefinedValues.toString()}`
    };
  } else {
    return undefined;
  }
};
exports.checkRequiredParameters = checkRequiredParameters;
// This function is used to interact with the OCAPI API
const createOcapiFetch = commerceAPIConfig => ( /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)(function* (endpoint, method, args, methodName, body, raw) {
    var _args$;
    const proxy = `/mobify/proxy/ocapi`;

    // The api config will only have `ocapiHost` during testing to workaround localhost proxy
    const host = commerceAPIConfig.ocapiHost ? `https://${commerceAPIConfig.ocapiHost}` : `${(0, _url.getAppOrigin)()}${proxy}`;
    const siteId = commerceAPIConfig.parameters.siteId;
    const headers = _objectSpread(_objectSpread({}, args[0].headers), {}, {
      'Content-Type': 'application/json',
      'x-dw-client-id': commerceAPIConfig.parameters.clientId
    });
    let apiUrl = `${host}/s/${siteId}/dw/shop/v21_3/${endpoint}`;
    const parsedApiUrl = _queryString.default.parseUrl(apiUrl);
    parsedApiUrl.query.locale = commerceAPIConfig.locale;
    apiUrl = `${parsedApiUrl.url}?${_queryString.default.stringify(parsedApiUrl.query)}`;
    if (method === 'GET' && (_args$ = args[0]) !== null && _args$ !== void 0 && _args$.parameters) {
      for (const [key, value] of Object.entries((_args$2 = args[0]) === null || _args$2 === void 0 ? void 0 : _args$2.parameters)) {
        var _args$2;
        apiUrl += `&${key}=${value}`;
      }
    }
    let response;
    response = yield (0, _crossFetch.default)(apiUrl, _objectSpread({
      method: method,
      headers: headers
    }, body && {
      body: JSON.stringify(body)
    }));
    const httpStatus = response.status;
    if (httpStatus === 204) {
      return {
        status: 204
      };
    }
    if (!args[1] && response.json) {
      response = yield response.json();
    }
    const convertedResponse = keysToCamel(response);
    if (convertedResponse.fault) {
      var _error$arguments;
      const error = convertOcapiFaultToCapiError(convertedResponse.fault);
      if (raw) {
        return error;
      }
      throw new _errors.HTTPError(httpStatus, ((_error$arguments = error.arguments) === null || _error$arguments === void 0 ? void 0 : _error$arguments.statusMessage) || error.detail);
    } else {
      return convertedResponse;
    }
  });
  return function (_x, _x2, _x3, _x4, _x5, _x6) {
    return _ref.apply(this, arguments);
  };
}());

// This function is used to interact with the SCAPI API
exports.createOcapiFetch = createOcapiFetch;
const createScapiFetch = (commerceAPIConfig, customApiName) => ( /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)(function* (endpoint, method, args, body, raw) {
    var _args$3;
    const proxy = `/mobify/proxy/api`;
    const host = `${(0, _url.getAppOrigin)()}${proxy}`;
    const headers = _objectSpread(_objectSpread({}, args[0].headers), {}, {
      'Content-Type': 'application/json'
    });
    let apiUrl = `${host}/custom/${customApiName}/v1/organizations/${commerceAPIConfig.parameters.organizationId}/${endpoint}`;
    const parsedApiUrl = _queryString.default.parseUrl(apiUrl);
    parsedApiUrl.query.siteId = commerceAPIConfig.parameters.siteId;
    apiUrl = `${parsedApiUrl.url}?${_queryString.default.stringify(parsedApiUrl.query)}`;
    if (method === 'GET' && (_args$3 = args[0]) !== null && _args$3 !== void 0 && _args$3.parameters) {
      for (const [key, value] of Object.entries((_args$4 = args[0]) === null || _args$4 === void 0 ? void 0 : _args$4.parameters)) {
        var _args$4;
        apiUrl += `&${key}=${value}`;
      }
    }
    let response;
    response = yield (0, _crossFetch.default)(apiUrl, _objectSpread({
      method: method,
      headers: headers
    }, body && {
      body: JSON.stringify(body)
    }));
    const httpStatus = response.status;
    if (httpStatus === 204) {
      return {
        status: 204
      };
    }
    if (response.json) {
      response = yield response.json();
    }
    const convertedResponse = keysToCamel(response);
    if (convertedResponse.fault) {
      var _error$arguments2, _error$arguments3;
      const error = convertOcapiFaultToCapiError(convertedResponse.fault);
      if (raw) {
        return error;
      }
      let _error = new _errors.HTTPError(httpStatus, ((_error$arguments2 = error.arguments) === null || _error$arguments2 === void 0 ? void 0 : _error$arguments2.statusMessage) || error.detail);
      _error.name = (error === null || error === void 0 ? void 0 : (_error$arguments3 = error.arguments) === null || _error$arguments3 === void 0 ? void 0 : _error$arguments3.statusCode) || httpStatus || 'SCAPI Error';
      throw _error;
    } else {
      return convertedResponse;
    }
  });
  return function (_x7, _x8, _x9, _x10, _x11) {
    return _ref2.apply(this, arguments);
  };
}());

// This function derrives the SF Tenant Id from the SF OrgId
exports.createScapiFetch = createScapiFetch;
const getTenantId = orgId => {
  // Derive tenant id id form org id
  const indexToStartOfTenantId = orgId.indexOf('_', orgId.indexOf('_') + 1);
  const tenantId = orgId.substring(indexToStartOfTenantId + 1);
  return tenantId;
};

/**
 * Indicates if an JSON response from the SDK should be considered an error
 * @param {object} jsonResponse - The response object returned from SDK calls
 * @returns {boolean}
 */
exports.getTenantId = getTenantId;
const isError = jsonResponse => {
  if (!jsonResponse) {
    return false;
  }
  const {
    detail,
    title,
    type
  } = jsonResponse;
  if (detail && title && type) {
    return true;
  }
  return false;
};

/**
 * Decorator that wraps functions to handle error response.
 * @param {function} func - A function which returns a promise
 * @returns {function}
 */
exports.isError = isError;
const handleAsyncError = func => {
  return /*#__PURE__*/(0, _asyncToGenerator2.default)(function* (...args) {
    const result = yield func(...args);
    if (isError(result)) {
      throw new Error(result.detail);
    }
    return result;
  });
};

/**
 * Converts snake-case strings to space separated or sentence case
 * strings by replacing '_' with a ' '.
 * @param {string} text snake-case text.
 * @returns {string} space separated string.
 */
exports.handleAsyncError = handleAsyncError;
const convertSnakeCaseToSentenceCase = text => {
  return text.split('_').join(' ');
};

/**
 * No operation function. You can use this
 * empty function when you wish to pass
 * around a function that will do nothing.
 * Usually used as default for event handlers.
 */
exports.convertSnakeCaseToSentenceCase = convertSnakeCaseToSentenceCase;
const noop = () => {};

/**
 * WARNING: This function is relevant to be used in Hybrid deployments only.
 * Compares the refresh_token keys for guest('cc-nx-g') and registered('cc-nx') login from the cookie received from SFRA with the copy stored in localstorage on PWA Kit
 * to determine if the login state of the shopper on SFRA site has changed. If the keys are different we return true considering the login state did change. If the keys are same,
 * we compare the values of the refresh_token to cover an edge case where the login state might have changed multiple times on SFRA and the eventual refresh_token key might be same
 * as that on PWA Kit which would incorrectly show both keys to be the same even though the sessions are different.
 * @param {Storage} storage Cookie storage on PWA Kit in hybrid deployment.
 * @param {LocalStorage} storageCopy Local storage holding the copy of the refresh_token in hybrid deployment.
 * @returns {boolean} true if the keys do not match (login state changed), false otherwise.
 */
exports.noop = noop;
function hasSFRAAuthStateChanged(storage, storageCopy) {
  let refreshTokenKey = storage.get(_constants.refreshTokenGuestStorageKey) && _constants.refreshTokenGuestStorageKey || storage.get(_constants.refreshTokenRegisteredStorageKey) && _constants.refreshTokenRegisteredStorageKey;
  let refreshTokenCopyKey = storageCopy.get(_constants.refreshTokenGuestStorageKey) && _constants.refreshTokenGuestStorageKey || storageCopy.get(_constants.refreshTokenRegisteredStorageKey) && _constants.refreshTokenRegisteredStorageKey;
  if (refreshTokenKey !== refreshTokenCopyKey) {
    return true;
  }
  return storage.get(refreshTokenKey) !== storageCopy.get(refreshTokenCopyKey);
}

/**
 * Checks the usage of the auth token based on the type of the token and the login email.
 * @param {string} type Type of check to be made, it depends on the function that is calling this function.
 * @param {string} accessToken Returned access token from the auth call.
 * @param {string} email If login was made by login form, the email used to login.
 * @returns {boolean} false if there was a token mismatch, true if only debug logs were captured.
 */

function checkAuthTokenUsage(type, accessToken, email) {
  var _decodedBody$isb, _decodedBody$isb$matc, _decodedBody$isb2, _decodedBody$isb2$mat, _decodedBody$isb3, _decodedBody$isb3$mat, _decodedBody$sub, _decodedBody$sub$matc, _decodedBody$sub2, _decodedBody$sub2$mat;
  const logPrefix = 'AUTH EVENT:';
  const decodedBody = (0, _jwtDecode.default)(accessToken);
  const decodedHeader = (0, _jwtDecode.default)(accessToken, {
    header: true
  });
  const upn = decodedBody === null || decodedBody === void 0 ? void 0 : (_decodedBody$isb = decodedBody.isb) === null || _decodedBody$isb === void 0 ? void 0 : (_decodedBody$isb$matc = _decodedBody$isb.match(/upn:([^:]+)/)) === null || _decodedBody$isb$matc === void 0 ? void 0 : _decodedBody$isb$matc[1];
  const additionalData = {
    kid: decodedHeader.kid,
    upn: upn,
    gcid: decodedBody === null || decodedBody === void 0 ? void 0 : (_decodedBody$isb2 = decodedBody.isb) === null || _decodedBody$isb2 === void 0 ? void 0 : (_decodedBody$isb2$mat = _decodedBody$isb2.match(/gcid:([^:]+)/)) === null || _decodedBody$isb2$mat === void 0 ? void 0 : _decodedBody$isb2$mat[1],
    rcid: decodedBody === null || decodedBody === void 0 ? void 0 : (_decodedBody$isb3 = decodedBody.isb) === null || _decodedBody$isb3 === void 0 ? void 0 : (_decodedBody$isb3$mat = _decodedBody$isb3.match(/rcid:([^:]+)/)) === null || _decodedBody$isb3$mat === void 0 ? void 0 : _decodedBody$isb3$mat[1],
    scid: decodedBody === null || decodedBody === void 0 ? void 0 : (_decodedBody$sub = decodedBody.sub) === null || _decodedBody$sub === void 0 ? void 0 : (_decodedBody$sub$matc = _decodedBody$sub.match(/scid:([^:]+)/)) === null || _decodedBody$sub$matc === void 0 ? void 0 : _decodedBody$sub$matc[1],
    usid: decodedBody === null || decodedBody === void 0 ? void 0 : (_decodedBody$sub2 = decodedBody.sub) === null || _decodedBody$sub2 === void 0 ? void 0 : (_decodedBody$sub2$mat = _decodedBody$sub2.match(/usid:([^:]+)/)) === null || _decodedBody$sub2$mat === void 0 ? void 0 : _decodedBody$sub2$mat[1]
  };
  try {
    switch (type) {
      case 'credAuth':
        {
          if (email && email.toLowerCase() !== (upn === null || upn === void 0 ? void 0 : upn.toLowerCase())) {
            additionalData['error info'] = {
              customerLoginEmail: email
            };
            Sentry.withScope(scope => {
              scope.setContext('Login Error', additionalData);
              Sentry.captureMessage(`${logPrefix} Credential and AccessToken mismatch`, 'error');
            });
            return false;
          }
          break;
        }
      case 'refreshToken':
        {
          if (email && email.toLowerCase() !== (upn === null || upn === void 0 ? void 0 : upn.toLowerCase())) {
            additionalData['error info'] = {
              customerLoginEmail: email
            };
            Sentry.withScope(scope => {
              scope.setContext('Login Error', additionalData);
              Sentry.captureMessage(`${logPrefix} Current token email and new token email mismatch`, 'error');
            });
            return false;
          }
          break;
        }
      case 'appAuth':
        {
          Sentry.withScope(scope => {
            scope.setContext('Login Error', additionalData);
            Sentry.captureMessage(`${logPrefix} Initial AuthToken used`, 'debug');
          });
          break;
        }
      default:
        break;
    }
  } catch (error) {
    Sentry.captureException(error);
  }
  return true;
}